const DEFAULT_APP_NAME = (process.env.VUE_APP_NAME || '盒子IM').trim() || '盒子IM'

function normalizeString(value) {
	return (typeof value === 'string' ? value.trim() : '') || '';
}

export function buildShellIdentity(userName, appName = DEFAULT_APP_NAME) {
	const normalizedUserName = normalizeString(userName);
	const normalizedAppName = normalizeString(appName) || DEFAULT_APP_NAME;
	if (normalizedUserName) {
		return normalizedUserName;
	}
	return normalizedAppName;
}

export function buildShellTitle(options = {}) {
	const { userName, tip, appName } = options;
	const prefix = normalizeString(tip);
	const identity = buildShellIdentity(userName, appName);
	if (prefix) {
		return `${identity} (${prefix})`;
	}
	return identity;
}

export function formatUnreadTip(count) {
	if (!Number.isFinite(count) || count <= 0) {
		return '';
	}
	return `${Math.floor(count)}条未读`;
}

export default {
	buildShellIdentity,
	buildShellTitle,
	formatUnreadTip
}
